export default "__VITE_ASSET__BGC4OcWv__"